import { useStore } from 'effector-react';
import React, { useEffect } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { not } from 'src/common/boolean';
import { LocalStorageKeys } from 'src/common/local-stoage-keys';
import { history } from 'src/history';

import { routes } from 'src/routes';
import { AuthRouter } from 'src/features/auth/auth.router';
import { HomeRouter } from 'src/features/home/home.router';
import { loadAuthFromLS } from 'src/store/auth.store';
import { user$ } from 'src/store/user.store';
import { AppContainer } from 'src/ui/atoms/app-container';

export function App() {
	const user = useStore(user$);
	const location = useLocation();

	useEffect(() => {
		const authData = localStorage.getItem(LocalStorageKeys.auth);

		if (not(authData) && not(location.pathname.includes('auth'))) {
			history.push(routes.root.auth.login.path);
		}
		if (authData && (location.pathname.includes('auth') || location.pathname === '/')) {
			history.push(routes.root.home.path);
		}
	}, [location]);

	useEffect(() => {
		if (localStorage.getItem(LocalStorageKeys.auth) === null && not(location.pathname.includes('auth'))) {
			history.push(routes.root.auth.login.path);
			return;
		}

		loadAuthFromLS();
	}, []);

	return (
		<AppContainer>
			<Switch>
				<Route path={routes.root.auth.path}>
					<AuthRouter/>
				</Route>
				<Route path={routes.root.home.path}>
					{user && <HomeRouter/>}
				</Route>
			</Switch>
		</AppContainer>
	);
}
